import { MeasurementPointResponse } from "@/components/Measurements/Types/MeasurementPoint";
import { CheckpointType } from "@/components/Procedures/Types/ManualChecklistTypes";
import { ProcedureChecklistType } from "@/model/Procedure/ProcedureChecklistType";
import { ProcedureDetailStepType } from "@/model/Procedure/ProcedureDetailStepType";
import { ProcedureListenerTag } from "@/model/Procedure/ProcedureListenerTag";
import {
	ChecklistOpenTask,
	ProcedureNodeStepComment,
} from "@/model/Procedure/ProcedureNodeStepComment";
import { ProcedureNodeStepManualReading } from "@/model/Procedure/ProcedureNodeStepManualReading";
import { ProcedureNodeStepStatusTypes } from "@/model/Procedure/ProcedureNodeStepStatus";
import { ProcedureStepAccessLevel } from "@/model/Procedure/ProcedureStepAccessLevel";

export class ProcedureNodeStep {
  constructor() {
    this.ProcedureUpdateSuggestions = [];
  }
  Id: number;
  StepId: string | number;
  AccessLevel: ProcedureStepAccessLevel;
  ActiveListenerTags: Array<ProcedureListenerTag>;
  ArchiveReference: string;
  ChecklistType: ProcedureChecklistType;
  Comments: Array<ProcedureNodeStepComment>;
  HasMultipleFields: boolean;
  Index: number;
  ManualReading: MeasurementPointResponse | undefined;
  ListenerTags: Array<ProcedureListenerTag>;
  ManualReadingValues: Array<ProcedureNodeStepManualReading>;
  NumberOfFields: number;
  Status: ProcedureNodeStepStatusTypes;
  StepType: ProcedureDetailStepType;
  OpenTasks: Array<ChecklistOpenTask>;
  UserName: string;
  Value: string | Element;
  GroupId: number;
  Readonly: boolean;
  IsModified: boolean;
  DeleteThis: boolean;
  ProcedureUpdateSuggestions: Array<any>;
  IsSkipped?: boolean;
  SavedTagValue?: number;
  SavedTagTimestamp?: string;
  IsOverridden?: boolean;
  BackgroundColor: string;
  CheckpointType: CheckpointType = CheckpointType.Checkpoint;
}

export type ProcedureNodeStepArchiveType = "Comment" | "Measurement" | "Status";
